
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vefverslun/karfa",
      function () {
        return require("private-next-pages/vefverslun/karfa/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vefverslun/karfa"])
      });
    }
  